import { render, staticRenderFns } from "./FlexAlign.vue?vue&type=template&id=1940be99&"
import script from "./FlexAlign.vue?vue&type=script&lang=js&"
export * from "./FlexAlign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports